var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.714,
    height: 24,
    viewBox: "0 0 25.714 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39.974,25.128A3.428,3.428,0,0,0,42.4,19.276a3.428,3.428,0,1,0-4.848,4.848A3.3,3.3,0,0,0,39.974,25.128Z",
    transform: "translate(-34.831 -18.271)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M165.956,100.142a5.141,5.141,0,1,0-1.507-3.636A4.956,4.956,0,0,0,165.956,100.142Z",
    transform: "translate(-156.735 -87.934)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M368.881,25.128a3.428,3.428,0,0,0,2.424-5.853,3.428,3.428,0,1,0-4.848,4.848A3.3,3.3,0,0,0,368.881,25.128Z",
    transform: "translate(-348.309 -18.271)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M385.141,164.456a2.562,2.562,0,0,0-.582.281,8.792,8.792,0,0,1-1.306.569,4.7,4.7,0,0,1-1.594.288,5.378,5.378,0,0,1-1.781-.308,6.707,6.707,0,0,1,.067.884,5.9,5.9,0,0,1-1.085,3.429,4.618,4.618,0,0,1,3.549,1.715H384.2a3.07,3.07,0,0,0,1.848-.543,1.835,1.835,0,0,0,.75-1.587Q386.8,164.456,385.141,164.456Z",
    transform: "translate(-361.088 -157.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M91.713,297.187a11.338,11.338,0,0,0-.355-1.453,6.9,6.9,0,0,0-.576-1.306,4.719,4.719,0,0,0-.831-1.085,3.5,3.5,0,0,0-1.145-.717,4.022,4.022,0,0,0-1.493-.268,1.578,1.578,0,0,0-.576.288q-.442.288-.978.643a6.219,6.219,0,0,1-6.482,0q-.536-.354-.978-.643a1.578,1.578,0,0,0-.576-.288,4.023,4.023,0,0,0-1.493.268,3.5,3.5,0,0,0-1.145.717,4.708,4.708,0,0,0-.831,1.085,6.885,6.885,0,0,0-.576,1.306,11.372,11.372,0,0,0-.355,1.453,13.613,13.613,0,0,0-.187,1.46q-.047.676-.047,1.386a3.337,3.337,0,0,0,.978,2.538,3.614,3.614,0,0,0,2.6.931H88.371a3.614,3.614,0,0,0,2.6-.931,3.337,3.337,0,0,0,.978-2.538q0-.71-.047-1.386A13.84,13.84,0,0,0,91.713,297.187Z",
    transform: "translate(-69.661 -279.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.942,169.6a5.9,5.9,0,0,1-1.085-3.429,6.69,6.69,0,0,1,.067-.884,5.382,5.382,0,0,1-1.781.308,4.7,4.7,0,0,1-1.594-.288,8.8,8.8,0,0,1-1.306-.569,2.558,2.558,0,0,0-.583-.281Q0,164.455,0,169.183a1.835,1.835,0,0,0,.75,1.587,3.071,3.071,0,0,0,1.848.542H4.393A4.618,4.618,0,0,1,7.942,169.6Z",
    transform: "translate(0 -157.598)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.9176028a.svg";
export { ForwardRef as ReactComponent };